function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function infiniteLoadMore(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      let loadMoreBtn = document.getElementById('load-more');
      var loadMoreSpinner = document.querySelector("#load-more img")
      let pathName = loadMoreBtn.dataset.next;

      if (loadMoreBtn) {
        let section = document.getElementById('product-grid').dataset.id;
        const url = `${window.origin + pathName}&section_id=${section}`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {

            const domParsed = new DOMParser().parseFromString(responseText, 'text/html');

            domParsed.getElementById('product-grid').querySelectorAll(".prod-block").forEach((p) => document.getElementById('product-grid').appendChild(p));

            let newLoadMoreBtn = domParsed.getElementById("load-more")
            if (newLoadMoreBtn) {
              loadMoreBtn.setAttribute("data-next", newLoadMoreBtn.dataset.next);
            } else {
              loadMoreBtn.classList.add("hidden");
            }
          });
        loadMoreSpinner.classList.remove("hidden");
      } else {
        loadMoreSpinner.classList.add("hidden");
      }
    }
  })
  StampedFn.reloadUGC();
  // Make sure jQuery is ready
  jQuery(document).ready(function ($) {
    setTimeout(function () {
      $('.prod-block').each(function () {
        // Find the aria-label text from the stamped badge
        var reviewLabel = $(this).find('.stamped-badge').attr('aria-label');

        // If it exists, copy it into the .sr-stamped-review span
        if (reviewLabel) {
          $(this).find('span.sr-stamped-review').text(reviewLabel);
        }
      });
    }, 2500);
  });
}

function setInfiniteScroll() {
  const infiniteScrollOptions = {
    rootMargin: '0px',
    threshold: 0.1,
  };

  const infiniteScroll = new IntersectionObserver(debounce(infiniteLoadMore, 800), infiniteScrollOptions);

  infiniteScroll.observe(document.getElementById('load-more'));
};

function countdown(dateEnd0, blockId) {
  var timer, days, hours, minutes, seconds;

  var dateEnd = new Date(dateEnd0);
  var dateEnd = new Date(
      dateEnd.getUTCFullYear(),
      dateEnd.getUTCMonth(),
      dateEnd.getUTCDate(),
      dateEnd.getUTCHours(),
      dateEnd.getUTCMinutes(),
      dateEnd.getUTCSeconds()
    );
  dateEnd = dateEnd.getTime();

  if (isNaN(dateEnd)) {
    return;
  }

  timer = setInterval(calculate, 1000);

  function calculate() {
    var dateStart = new Date();
    var dateStart = new Date();

    var timezoneOffset = dateStart.getTimezoneOffset() * 120;
    console.log("asdasdsads" + timezoneOffset)
    var timeRemaining = parseInt((dateEnd - dateStart.getTime()) / 1000) - timezoneOffset;

    if (timeRemaining >= 0) {
      days = parseInt(timeRemaining / 86400);
      timeRemaining = timeRemaining % 86400;
      hours = parseInt(timeRemaining / 3600);
      timeRemaining = timeRemaining % 3600;
      minutes = parseInt(timeRemaining / 60);
      timeRemaining = timeRemaining % 60;
      seconds = parseInt(timeRemaining);

      document.querySelector('#countdown-timer-' + blockId + ' .days').innerHTML = parseInt(days, 10);
      document.querySelector('#countdown-timer-' + blockId + ' .hours').innerHTML = ('0' + hours).slice(-2);
      document.querySelector('#countdown-timer-' + blockId + ' .min').innerHTML = ('0' + minutes).slice(-2);
      document.querySelector('#countdown-timer-' + blockId + ' .sec').innerHTML = ('0' + seconds).slice(-2);
    } else {
      return;
    }
  }

  function display(days, hours, minutes, seconds) { }
}